import { render } from "./DocumentsDansukCatalogs.vue?vue&type=template&id=6d0cf9da&scoped=true"
import script from "./DocumentsDansukCatalogs.vue?vue&type=script&lang=js"
export * from "./DocumentsDansukCatalogs.vue?vue&type=script&lang=js"

import "./DocumentsDansukCatalogs.vue?vue&type=style&index=0&id=6d0cf9da&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0cf9da"]])

export default __exports__